// Kunder (no).
window.PlummeI18n.register('no', {
  'sup.archiveBody': 'Vil du flytte {name} til arkivet? Leverandøren skjules fra aktive leverandørlister, men fakturaer, betalinger og historikk beholdes. Du kan åpne leverandøren igjen senere.',
  // ------------------------------------------------------------------ Kunder
  'cust.title': 'Kunder',
  'cust.subtitle': 'Alle kundene dine på ett sted',
  'cust.searchPh': 'Søk på kunde eller beløp',
  'cust.titleHelp': 'Kunderegisteret ditt — alle kunder med kontaktinfo, utestående og samlet salg. Trykk på en kunde for å se oppfølging og fakturaer.',
  'cust.searchHelp': 'Søk i kundene på navn, e-post, samlet salg eller utestående beløp.',
  'cust.uploadHelp': 'Importer kunder fra en fil.',
  'cust.downloadHelp': 'Last ned kundelisten som CSV eller Excel.',
  'cust.addHelp': 'Legg til en ny kunde med kontaktinfo og oppfølgingsstatus.',
  'cust.filterHelp': 'Filtrer kundene på status (aktiv, prospekt, tilbud sendt, på pause), om de har utestående, og om arkiverte skal vises.',
  'cust.listHelpTitle': 'Kundelisten',
  'cust.listHelp': 'Hver rad er én kunde med kundenr., org.nr., e-post, telefon, utestående og samlet salg. Trykk på en rad for å åpne kunden.',
  'cust.filterOther': 'Annet',
  'cust.filterWithOutstanding': 'Kun med utestående',
  'cust.filterShowArchive': 'Vis arkiv',
  'cust.archived': 'Arkivert',
  'cust.followUpInline': 'Oppfølging {date}',

  'cust.col.customer': 'Kunde',
  'cust.col.number': 'Kundenr.',
  'cust.col.org': 'Org.nr.',
  'cust.col.email': 'E-post',
  'cust.col.phone': 'Telefon',
  'cust.col.outstanding': 'Utestående',
  'cust.col.totalSales': 'Total salg',
  'cust.outstandingInline': 'Utestående {amount}',
  'cust.balance.customerOwes': 'Kunden skylder deg {amount}',
  'cust.balance.youOwe': 'Du skylder kunden {amount}',
  'cust.balance.settled': 'Ajour',

  'cust.followUp': 'Oppfølging',
  'cust.followUpHelp': 'Status, neste oppfølgingsdato, notater og siste aktiviteter for kunden. Bruk chat-knappen for å logge dialog og lage tilbud.',
  'cust.dialogTitle': 'Kundedialog',
  'cust.dialogHelp': 'Åpne en samtale med kunden — logg meldinger og bygg et tilbudsgrunnlag du kan gjøre om til et tilbud.',
  'cust.openChat': 'Åpne chat',
  'cust.startChat': 'Start chat',
  'cust.nextFollowUp': 'Neste oppfølging',
  'cust.noFollowUpDate': 'Ingen dato satt',
  'cust.status': 'Status',
  'cust.salesTitle': 'Salg på kunden',
  'cust.salesHelp': 'Alle fakturaer og kreditnotaer for kunden. Filtrer på alle, ikke betalt eller betalt — og åpne en faktura direkte med «Åpne».',
  'cust.salesAll': 'Alle',
  'cust.salesUnpaid': 'Ikke betalt',
  'cust.salesPaid': 'Betalt',
  'cust.salesTotal': 'Totalt',
  'cust.noSalesMatch': 'Ingen salg passet filteret.',
  'cust.creditNote': 'Kreditnota',
  'cust.invoice': 'Faktura',
  'cust.dueOn': 'Forfaller {date}',
  'cust.open': 'Åpne',
  'cust.pageRange': '{from}-{to} av {total}',
  'cust.prev': 'Forrige',
  'cust.next': 'Neste',

  'cust.act.newInvoice': 'Ny faktura',
  'cust.act.newInvoiceHelp': 'Start en ny faktura med denne kunden allerede valgt.',
  'cust.act.edit': 'Rediger',
  'cust.act.editHelp': 'Endre kundens kontaktinfo, status og oppfølging.',
  'cust.act.merge': 'Slå sammen',
  'cust.act.mergeHelp': 'Slå sammen to kunder som er registrert dobbelt — salg og utestående slås sammen på én kunde.',
  'cust.act.archive': 'Flytt til arkiv',
  'cust.act.archiveHelp': 'Skjul kunden fra aktive lister. Fakturaer, betalinger og historikk beholdes.',
  'cust.act.menu': 'Handling',

  'cust.archiveTitle': 'Flytt til arkiv?',
  'cust.archiveBody': 'Vil du flytte {name} til arkivet? Kunden skjules fra aktive kundelister, men fakturaer, betalinger og historikk beholdes.',
  'cust.archiveStillUsed': 'Kunden brukes fortsatt andre steder',
  'cust.archiveGroup': '{n} kundegruppe',
  'cust.archiveGroups': '{n} kundegrupper',
  'cust.archiveSubscription': '{n} abonnement',
  'cust.archiveSubscriptions': '{n} abonnementer',
  'cust.archiveAnd': ' og ',

  'cust.merge.title': 'Slå sammen kunder',
  'cust.merge.keep': 'Beholdes',
  'cust.merge.remove': 'Slås sammen og fjernes',
  'cust.merge.swap': 'Bytt hvilken kunde som beholdes',
  'cust.merge.after': 'Etter sammenslåing',
  'cust.merge.name': 'Kundenavn',
  'cust.merge.totalSales': 'Total salg',
  'cust.merge.notConnected': 'Sammenslåing er ikke koblet til backend ennå.',
  'cust.merge.done': 'Kundene ble slått sammen',
  'cust.merge.failed': 'Kunne ikke slå sammen kundene.',

  'cust.form.name': 'Kundenavn',
  'cust.form.namePh': 'F.eks. Eksempel AS',
  'cust.form.orgOptional': 'Org. nummer (valgfritt)',
  'cust.form.org': 'Org. nummer',
  'cust.form.address': 'Adresse',
  'cust.form.addressPh': 'Gateadresse',
  'cust.form.zip': 'Postnr',
  'cust.form.city': 'Poststed',
  'cust.form.cityPh': 'Sted',
  'cust.form.crm': 'Kundestatus',
  'cust.form.nextLabel': 'Neste: {date}',
  'cust.form.noFollowUp': 'Ingen oppfølging',
  'cust.form.dupTitle': 'Dette finnes allerede på en annen kunde',
  'cust.form.dupName': '{names} har samme navn.',
  'cust.form.dupOrg': '{names} har samme organisasjonsnummer.',
  'cust.form.dupEmail': '{names} har samme e-postadresse.',
  'cust.form.dupPhone': '{names} har samme telefonnummer.',
  'cust.form.dupUnnamed': 'En kunde uten navn',
  'cust.form.dupBody': 'Kunden lagres som vanlig. Er dette den samme kunden, kan du slå de to sammen fra kundekortet i listen.',
  'cust.form.contacts': 'Kontaktpersoner',
  'cust.form.contactsSub': 'Kan velges som mottaker når du sender faktura, tilbud eller kvittering.',
  'cust.form.addContact': 'Legg til kontaktperson',
  'cust.form.editContact': 'Rediger kontaktperson',
  'cust.form.contactFallback': 'Kontaktperson {n}',
  'cust.form.removeContact': 'Fjern kontaktperson',
  'cust.form.contactTitle': 'Kontaktperson',
  'cust.form.newTitle': 'Ny kunde',
  'cust.form.editTitle': 'Rediger kunde',
  'cust.form.saveContact': 'Lagre',
  'cust.form.contactName': 'Navn',
  'cust.form.contactNamePh': 'F.eks. Kari Nordmann',
  'cust.form.contactRole': 'Rolle',
  'cust.form.contactRolePh': 'F.eks. Regnskap',
  'cust.form.defaultRef': 'Fast fakturareferanse',
  'cust.form.defaultRefPh': 'F.eks. prosjektnummer, innkjøpsordre eller avdeling',
  'cust.form.creditLimit': 'Kredittgrense',
  'cust.form.creditLimitHint': 'Brukes i avstemmingen for å måle kundens åpne saldo mot foretakets egen kredittpolicy. Ingen grense sperrer fakturering.',
  'cust.form.creditLimitPh': 'F.eks. 60000',
  'cust.form.note': 'Kundenotat',
  'cust.form.notePh': 'Notat om kunden',
  'cust.form.activity': 'Legg til aktivitetsnotat',
  'cust.form.activityPh': 'Ringte kunde, sendte prisoppdatering…',
  'cust.form.update': 'Oppdater kunde',
  'cust.form.save': 'Lagre kunde',

  'cust.crm.prospect': 'Prospekt',
  'cust.crm.quoteSent': 'Tilbud sendt',
  'cust.crm.active': 'Aktiv kunde',
  'cust.crm.pause': 'På pause',

  'cust.chat.scope.all': 'Hele samtalen',
  'cust.chat.scope.to': 'Til kunde',
  'cust.chat.scope.from': 'Fra kunde',
  'cust.chat.scope.internal': 'Interne notater',
  'cust.chat.helpAll': 'Du ser nå hele samtalen.',
  'cust.chat.helpTo': 'Du ser nå meldinger du har sendt.',
  'cust.chat.helpFrom': 'Du ser nå meldinger fra kunden.',
  'cust.chat.helpInternal': 'Dette er dine interne notater i dialogen.',
  'cust.chat.threadsHelpTitle': 'Samtaler',
  'cust.chat.threadsHelp': 'Hver kunde kan ha flere samtaler. Bytt mellom dem her, eller start en ny dialog for en ny henvendelse.',
  'cust.chat.conversation': 'Samtale',
  'cust.chat.filterTitle': 'Filtrer samtalen',
  'cust.chat.filterHelp': 'Velg hva du vil se i vinduet under: hele samtalen, meldinger du har sendt, meldinger fra kunden eller interne notater.',
  'cust.chat.windowTitle': 'Samtalevindu',
  'cust.chat.windowHelp': 'Meldingene i dialogen. Det du sender vises til høyre, kundens meldinger og interne notater til venstre. Dra nederste kant for å gjøre vinduet større.',
  'cust.chat.internal': 'Internt',
  'cust.chat.newInternalTitle': 'Nytt internt notat',
  'cust.chat.saveInDialog': 'Lagre i dialog',
  'cust.chat.saveMessage': 'Lagre melding',
  'cust.chat.sendMessage': 'Send melding',
  'cust.chat.newTitle': 'Ny melding',
  'cust.chat.newHelp': 'Skriv et svar til kunden, lim inn en melding du har fått, eller noter noe internt. Valgt samtalefilter styrer om dette blir sendt til kunde, lagret som kundemelding eller lagret som internt notat.',
  'cust.chat.draftPh': 'Skriv svar, lim inn kundemelding, eller noter hva dere ble enige om...',
  'cust.chat.newDialog': 'Ny dialog',
  'cust.chat.quoteTitle': 'Tilbudsgrunnlag',
  'cust.chat.quoteHelp': 'Legg til produktene og prisene dere ble enige om i samtalen. Trykk Lag tilbud for å gjøre det om til et tilbudsutkast med kunden ferdig utfylt.',
  'cust.chat.findProduct': 'Finn produkt/pris',
  'cust.chat.productPh': 'Søk produktnavn...',
  'cust.chat.dragToMessage': 'Dra til meldingen',
  'cust.chat.dragTotal': 'Dra total til meldingen',
  'cust.chat.dragBasis': 'Dra hele tilbudsgrunnlaget til meldingen',
  'cust.chat.quoteBasis': 'Hele grunnlaget',
  'cust.chat.remove': 'Fjern',
  'cust.chat.total': 'Total',
  'cust.chat.makeQuote': 'Lag tilbud',

  'cust.toast.updated': 'Kunde oppdatert',
  'cust.toast.saved': 'Kunde lagret',
  'cust.toast.saveFailed': 'Kunne ikke lagre kunden.',
  'cust.toast.archived': 'Kunde flyttet til arkiv',
  'cust.toast.archiveFailed': 'Kunne ikke arkivere kunden.',
  'cust.toast.nothingToExport': 'Ingen kunder å eksportere',
  'cust.toast.exportFailed': 'Kunne ikke eksportere kundelisten.',
  'cust.toast.exported': 'Kundeliste lastet ned',
  'cust.toast.noLedgerRows': 'Ingen reskontrolinjer å eksportere',
  'cust.toast.ledgerExportFailed': 'Kunne ikke eksportere kundereskontro.',
  'cust.toast.ledgerExported': 'Kundereskontro lastet ned',
  'cust.toast.wrongFormat': 'Bruk CSV eller XLSX med Plumme kundemal.',
  'cust.toast.noneInFile': 'Fant ingen kunder i filen.',
  'cust.toast.imported': '{n} kunder importert',
  'cust.toast.importFailed': 'Kunne ikke importere kunder.',
  'cust.error.xlsxImport': 'XLSX-import er ikke tilgjengelig ennå.',
  'cust.error.xlsxExport': 'Excel-eksport er ikke tilgjengelig ennå.',

  // Kolonneoverskrifter i CSV/Excel. De engelske variantene er valgt slik at de
  // normaliserer til aliasene importparseren allerede godtar, så en eksportert
  // fil kan importeres tilbake uansett språk.
  'cust.export.number': 'Kundenr.',
  'cust.export.name': 'Navn',
  'cust.export.org': 'Orgnr',
  'cust.export.email': 'E-post',
  'cust.export.phone': 'Telefon',
  'cust.export.address': 'Adresse',
  'cust.export.zip': 'Postnr',
  'cust.export.city': 'Poststed',
  'cust.export.status': 'Status',
  'cust.export.followUp': 'Neste oppfølging',
  'cust.export.defaultRef': 'Fast fakturareferanse',
  'cust.export.note': 'Notat',
  'cust.ledger.code': 'Kode',
  'cust.ledger.date': 'Dato',
  'cust.ledger.doc': 'Bilagsnr/fakturanr',
  'cust.ledger.type': 'Type',
  'cust.ledger.due': 'Forfall',
  'cust.ledger.debit': 'Debet',
  'cust.ledger.credit': 'Kredit',
  'cust.ledger.balance': 'Saldo etter linje',
  'cust.ledger.paid': 'Betalt',
  'cust.ledger.remaining': 'Gjenstår',
  'cust.ledger.partial': 'Delbetalt',
  'cust.ledger.unpaid': 'Ikke betalt',
  'cust.ledger.posted': 'Bokført',
  'cust.ledger.refund': 'Tilbakebetaling kunde',
  'cust.ledger.payment': 'Kundeinnbetaling',
  'cust.ledger.creditOverpayment': 'Kredit / overbetaling',
  'cust.ledger.empty': 'Ingen reskontrolinjer ennå.',
  'cust.import': 'Importer',
  'cust.importFrom': 'Importer fra',
  'cust.ledgerShort': 'Reskontro',
  'cust.ledger.sheet': 'Kundereskontro',
  'cust.sheet.customers': 'Kunder',

});
